import pluralize from 'pluralize';
import React from 'react';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import { useApi, useWorkspace } from '~/contexts';
import ExpenseItemDetails from './ExpenseItemDetails';

export default function BulkDelete({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Delete"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .expenseAdmin()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={ExpenseItemDetails}>
      {`Are you sure you want to delete ${ids.length} ${pluralize('expense item', ids.length)}? This action cannot be undone.`}
    </BulkActionModal>
  );
}
